// @flow

import { StateListenerRegistry } from '../base/redux';
import { setSensoringDebugMode } from '../large-video';
import { toggleSensoringEffect } from '../virtual-background/actions';
/**
 * Updates the on stage participant video.
 */
StateListenerRegistry.register(
  /* selector */ (state) => state['features/login'].user?.device?.options,
  /* listener */ (options, store) => {
    const state = store.getState();
    const { sensoringEffectEnabled } = state['feature/virtual-background'];
    const { sensoringDebugMode } = state['features/large-video'];
    if (options?.enableCensorship != sensoringEffectEnabled) {
      store.dispatch(toggleSensoringEffect(options?.enableCensorship === 1));
    }
    if (options?.censorshipDebugMode != sensoringDebugMode) {
      store.dispatch(setSensoringDebugMode(options?.censorshipDebugMode === 1));
    }
  },
  {
    deepEquals: true
  }
);
